import Vue from "vue";
import store from "./store";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router/router";
import "./filters";
import Transitions from 'vue2-transitions'
import VuePageTransition from "vue-page-transition";
import main_registrations from "./main_registrations";
import moment from "moment";

import "./assets/css/app-css-registration";
import api from "./services/api";

Vue.config.productionTip = false;

// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.use(Transitions)
Vue.use(VuePageTransition);
//Moment filter
Vue.filter("timeStringToStringHHmm", function(value) {
	if (!value) return "";
	var tt = value.split(":");
	if (tt.length < 1) return value;
	return `${tt[0]}:${tt[1]}`;
});

main_registrations.init();

router.beforeEach((to, from, next) => {
	const isAuthenticated = store.getters.getIsAuthenticated;
	const allowanonymous = to.meta.allowanonymous;
	if (allowanonymous || isAuthenticated) {
		next();
	} else {
		const loginpath = to.fullPath;
		next({ name: "login", query: { returnUrl: loginpath } });
	}
});
api.init(store);

//login from SFA
if (window.location && window.location.search && window.location.search.indexOf("?token=") >= 0) {
	var token = window.location.search.substr(1).replace("token=", "");

	if (token) {
		localStorage.setItem("staging-management-token", token);
		//window.location.replace(window.location.origin);
		history.pushState({
			id: 'homepage'
		}, 'Home', window.location.origin);
	}
}
api.getUserInfo()
	.then(userData => {
		store.commit("setUser", userData);
		createApp();
	})
	.catch(() => {
		store.dispatch("logoutUser").finally(() => createApp());
	});

function createApp() {
	new Vue({
		router,
		store,
		render: h => h(App)
	}).$mount("#app");
}
